import React, { FC } from 'react';
import { AudioPlayControls } from 'app/components/Song/Audio/AudioPlayControls';
import { AudioTitle } from 'app/components/Song/Audio/AudioTitle';
import { Box, Center, Flex, Tooltip } from '@chakra-ui/react';
import { PreferredAudioSelectionOption } from './types';

interface AudioVersionOptionProps {
  option: PreferredAudioSelectionOption;
  songTitle: string;
  versionSongGuid: string;
  tooltip?: string;
}

export const AudioVersionOption: FC<AudioVersionOptionProps> = ({
  option,
  songTitle,
  versionSongGuid,
  tooltip,
}) => {
  const { audioData } = option;
  const isLoading = ({ isAudioLoading, audioPlayerGuid }) =>
    isAudioLoading && audioData.guid === audioPlayerGuid;

  return (
    <Tooltip label={tooltip}>
      <Flex
        justify="space-between"
        alignItems="center"
        width="100%"
        data-testid={option.value}
      >
        <Center maxWidth="100%">
          <AudioPlayControls
            isLoading={isLoading}
            audioGuid={audioData.guid}
            parentGuid={audioData.parent}
            songDetails={{ title: songTitle }}
            versionSongGuid={versionSongGuid}
          />
          <Box pl={2} overflow="hidden">
            <AudioTitle
              audioGuid={audioData.guid}
              title={audioData.title}
              isLatestVersion={audioData.isLatestVersion}
            />
          </Box>
        </Center>
      </Flex>
    </Tooltip>
  );
};
